import { Box, Flex, useMantineTheme } from '@mantine/core';
import classNames from 'classnames';
import numeral from 'numeral';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@feathr/components';

import * as styles from './ChannelBudgetSplit.css';

interface IBudgetBreakdownProps {
  displayBudget: number;
  displayPercent: number;
  metaBudget: number;
}

function BudgetBreakdown({
  displayBudget,
  displayPercent,
  metaBudget,
}: Readonly<IBudgetBreakdownProps>): JSX.Element {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const metaPercent = 100 - displayPercent;

  return (
    <Flex className={styles.budgetBreakdown}>
      <Flex className={styles.budgetColumn} direction={'column'} gap={theme.spacing['1']}>
        <Text.SmallMedium>{t('Display budget')}</Text.SmallMedium>
        <Flex align={'baseline'} gap={theme.spacing['2_half']}>
          <Text.LargeSemibold>{numeral(displayBudget).format('$0,0.00')}</Text.LargeSemibold>
          <Text.SmallMedium>{t('({{percent}}%)', { percent: displayPercent })}</Text.SmallMedium>
        </Flex>
      </Flex>
      <Box className={styles.budgetDivider} />
      <Flex
        className={classNames(styles.budgetColumn, styles.metaColumn)}
        direction={'column'}
        gap={theme.spacing['1']}
      >
        <Text.SmallMedium>{t('Meta budget')}</Text.SmallMedium>
        <Flex align={'baseline'} gap={theme.spacing['2_half']} justify={'flex-end'}>
          <Text.LargeSemibold>{numeral(metaBudget).format('$0,0.00')}</Text.LargeSemibold>
          <Text.SmallMedium>{t('({{percent}}%)', { percent: metaPercent })}</Text.SmallMedium>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default BudgetBreakdown;
